import { IAttr } from "@/props/IProduct";
import { onKeyActivate } from "@/utils/index";

/**
 * 产品规格
 * @param attrs 规格列表
 * @param attrSelect 已选中规格
 * @param isMobile 是否手机端
 * @param getCurSpecStock 获取当前规格是否有库存
 * @param onSpecChange 规格选择改变
 * @returns
 */
const ProductAttr = ({
  attrs,
  attrSelect,
  isMobile = false,
  getCurSpecStock,
  onSpecChange,
}: {
  attrs: IAttr[];
  attrSelect: object;
  isMobile?: boolean;
  getCurSpecStock: (attrName: string, item: any) => number;
  onSpecChange: (attrName: string, spec: any) => void;
}) => {
  // 产品规格 item
  const SpecItem = ({
    attrName,
    spec,
    isSelect,
    disabled,
  }: {
    attrName: string;
    spec: string;
    isSelect: boolean;
    disabled: boolean;
  }) => {
    // disabled status
    if (disabled)
      return (
        <div className="mb-0 mr-0 h-10 min-w-[155px] cursor-not-allowed rounded border border-stone-200 bg-gray-100 px-2 py-[10px] text-center text-gray-800 md:mb-2 md:mr-[15px] [&:nth-child(4n)]:mr-0">
          {spec}
          {disabled}
        </div>
      );

    // select status
    if (isSelect) {
      return (
        <div
          className="mb-0 mr-0 h-10 min-w-[155px] cursor-pointer rounded border border-primary px-2 py-[10px] text-center text-primary md:mb-2 md:mr-[15px] [&:nth-child(4n)]:mr-0"
          onClick={() => {
            onSpecChange(attrName, spec);
          }}
          role="button"
          tabIndex={0}
          onKeyDown={onKeyActivate(() => onSpecChange(attrName, spec))}
          data-qt="mall_detail_spec_select"
          data-qt-attr-name={attrName}
          data-qt-spec={spec}
          data-qt-selected="1"
        >
          {spec}
        </div>
      );
    } else {
      return (
        <div
          className="mb-0 mr-0 h-10 min-w-[155px] cursor-pointer rounded border border-stone-200 px-2 py-[10px] text-center text-stone-300 transition-colors hover:border-primary hover:text-primary md:mb-2 md:mr-[15px] [&:nth-child(4n)]:mr-0"
          onClick={() => {
            onSpecChange(attrName, spec);
          }}
          role="button"
          tabIndex={0}
          onKeyDown={onKeyActivate(() => onSpecChange(attrName, spec))}
          data-qt="mall_detail_spec_select"
          data-qt-attr-name={attrName}
          data-qt-spec={spec}
          data-qt-selected="0"
        >
          {spec}
        </div>
      );
    }
  };

  return (
    <>
      {attrs.map((attr: IAttr, attrIndex: number) => (
        <div
          className={`flex flex-col ${!isMobile ? "mt-4" : "mt-6"}`}
          key={attrIndex}
        >
          <div className="mr-4">{attr.attrName}:</div>
          <div className="mt-2 grid grid-cols-1 flex-wrap gap-4 2xs:grid-cols-2 sm:grid-cols-3 md:flex">
            {attr.attrValue.map((item, index) => (
              <SpecItem
                attrName={attr.attrName}
                spec={item}
                isSelect={item === attrSelect[attr.attrName]}
                key={index}
                disabled={getCurSpecStock(attr.attrName, item) === 0}
              ></SpecItem>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default ProductAttr;
